<template>
  <div class="m-l-50 m-t-30" v-loading="isLoading">
    <common-config :id="id" :form="form" :inputList="inputList" :isLimit="false">
      <template slot="self-config">
        <el-form-item label="提醒信息">
          <el-select v-model="form.iframe.msg_field_id">
            <el-option v-for="item in typeOptions" :label="item.field + '(' + item.title + ')'" :value="item.field_id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="URL链接">
          <el-select v-model="form.iframe.url_field_id">
            <el-option v-for="item in typeOptions" :label="item.field + '(' + item.title + ')'" :value="item.field_id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否允许新建窗口打开">
          <el-radio class="radio" v-model="form.iframe.iframeCanOpen" label="1">允许</el-radio>
          <el-radio class="radio" v-model="form.iframe.iframeCanOpen" label="0">不允许</el-radio>
        </el-form-item>
      </template>
    </common-config>
  </div>
</template>

<script>
  import http from '../../../../assets/js/http'
  import flowConfig from '../../../../config/flowConfig'
  import commonConfig from './commonConfig'
  export default {
    data() {
      return {
        isLoading: false,
        id: 0,
        contentId: '',
        modelId: '',
        form: {
          name: '',  // 操作名
          rule_name: '', // 权限标识
          model_name: '',  // 所选模型
          iframe: {
            iframeCanOpen: '1',
            msg_field_id: '',
            url_field_id: ''
          } // iframe配置
        },
        typeOptions: []
      }
    },
    methods: {
      getDetail() {
        this.isLoading = true
        this.apiGet(`cms/deals/${this.id}`).then((res) => {
          if (res.code == 200) {
            this.form.name = res.data.content_name
            this.form.rule_name = res.data.rule_name
            this.form.model_name = res.data.model_name
            if (res.data.config && !(res.data.config.constructor === Array)) {
              this.form.iframe = res.data.config.iframe
            }
            this.modelId = res.data.model_id
            this.getDealfields()
          } else {
            _g.dealError(this, res)
          }
          this.isLoading = false
        })
      },
      getDealfields() {
        this.apiGet(`cms/deals/dealfields/${this.id}`).then((res) => {
          if (res.code == 200) {
            this.typeOptions = res.data
          } else {
            _g.dealError(this, res)
          }
        })
      },
      save() {
        this.isLoading = true
        let config = _.cloneDeep(this.form)
        delete config.name
        delete config.rule_name
        delete config.model_name
        let postData = {
          config: config
        }
        this.apiPut(`cms/deals/${this.id}`, '', postData).then((res) => {
          if (res.code == 200) {
            _g.toastMsg(this, 'success', '保存成功！')
            setTimeout(() => {
              this.goback()
            }, 1000)
          } else {
            _g.dealError(this, res)
            this.isLoading = false
          }
        })
      },
      goback() {
        router.go(-1)
      }
    },
    created() {
      this.id = parseInt(this.$route.params.id)
      this.contentId = parseInt(this.$route.params.contentId)
      this.getDetail()
    },
    components: {
      commonConfig
    },
    mixins: [http, flowConfig]
  }
</script>


// WEBPACK FOOTER //
// iframeConfig.vue?e5e72d0c